import { render, staticRenderFns } from "./ResetResultsButton.vue?vue&type=template&id=6dcff754&scoped=true&"
import script from "./ResetResultsButton.vue?vue&type=script&lang=js&"
export * from "./ResetResultsButton.vue?vue&type=script&lang=js&"
import style0 from "./ResetResultsButton.vue?vue&type=style&index=0&id=6dcff754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcff754",
  null
  
)

export default component.exports